// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(vehicleStatus) {
  switch (vehicleStatus) {
    case "Offline" :
        return /* Online */1;
    case "OnOrder" :
        return /* OnOrder */0;
    case "Online" :
        return /* Offline */2;
    default:
      return ErrorUtils$Catalyst.raiseError("VehicleStatus.re", "Invalid 'vehicleStatus' ", vehicleStatus);
  }
}

function toString(vehicleStatus) {
  switch (vehicleStatus) {
    case /* OnOrder */0 :
        return "OnOrder";
    case /* Online */1 :
        return "Online";
    case /* Offline */2 :
        return "Offline";
    
  }
}

export {
  fromString ,
  toString ,
  
}
/* No side effect */
